import { useParams } from 'react-router';
import type { Rol } from '@condo/contracts';
import { useAuth } from './use-auth';

/**
 * Derives the active condominio context from the current session + URL params.
 *
 * Returns:
 *   - `condoId`: the active tenant ID from URL :condoId param.
 *   - `rol`: the effective role for this condoId. For super_admin users,
 *     returns `'super_admin'`. Undefined when the user has no membership
 *     in the active condoId.
 *
 * This hook is only meaningful inside /app/condominios/:condoId/* routes
 * (i.e., inside TenantShell). Outside that subtree condoId will be empty.
 */
export function useCondoContext(): { condoId: string; rol: Rol | undefined } {
  const { session } = useAuth();
  const { condoId: condoIdParam } = useParams<{ condoId?: string }>();

  if (!session) return { condoId: '', rol: undefined };

  const condoId = condoIdParam ?? '';

  if (session.isSuperAdmin) {
    return { condoId, rol: 'super_admin' };
  }

  const rol = condoId ? (session.tenants[condoId] as Rol | undefined) : undefined;
  return { condoId, rol };
}
